import store from '../store'
import router from '../router'
import {OBTAIN_AUTHENTICATION, SET_ACCOUNT} from '../store/mutation-types'
import {alert} from '../utils/dlg'
import {login} from '../api/auth/wx-login'

export default {
  beforeRouteEnter (to, from, next) {
    let code = to.query.code
    login(code, ({body: {result, msg, token, account, openid}}) => {
      switch (result) {
        case 0:
          store.commit(OBTAIN_AUTHENTICATION, token)
          store.commit(SET_ACCOUNT, account)
          router.push({name: 'Home'})
          break
        case 1:
          alert(msg)
          break
        case 2:  // 用户未绑定微信
        case 3:  // 用户离职或经销商平台用户
          alert(msg, () => {
            router.push({name: 'Login', params: {openid: openid}})
          })
          break
      }
    }, (error) => {
      if (error.body && error.body.message) alert(error.body.message)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/wx-token-getter.js